// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"cf62e4da","118":"601935cc","191":"31258bfb","234":"22129d2e","395":"4d702517","422":"23ea3dd1","594":"24f05472","629":"fd5853f7","837":"9e8d1da7","869":"48f25a06"}[chunkId] + ".chunk.js";
};